import {
  USGA_COURSE_REFRESH_PATH as SharedUsgaCourseRefreshPath,
  USGA_COURSE_REFRESH_STATUSES as SharedUsgaCourseRefreshStatuses,
} from "shared/dist/types/UsgaCourseRefresh";

export type {
  UsgaCourseRefresh,
  UsgaCourseRefreshStatus,
  UsgaCourseRefreshTrigger,
} from "shared/dist/types/UsgaCourseRefresh";

export const USGA_COURSE_REFRESH_PATH = SharedUsgaCourseRefreshPath;
export const USGA_COURSE_REFRESH_STATUSES = SharedUsgaCourseRefreshStatuses;
